import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';

interface Exercise {
  name: string;
  duration: number;
  completed: boolean;
  description?: string;
}

interface WorkoutProgressProps {
  exercises: Exercise[];
  currentExerciseIndex: number;
}

export function WorkoutProgress({ exercises, currentExerciseIndex }: WorkoutProgressProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Activity className="w-5 h-5 text-primary" />
          <h3 className="font-medium">Workout Progress</h3>
        </div>
        <div className="text-sm text-muted-foreground">
          {currentExerciseIndex + 1}/{exercises.length}
        </div>
      </div>

      <div className="space-y-2">
        {exercises.map((exercise, index) => (
          <motion.div
            key={index}
            initial={false}
            animate={{
              opacity: exercise.completed ? 0.5 : 1,
              scale: index === currentExerciseIndex ? 1.02 : 1
            }}
            className={`p-3 rounded-lg ${
              index === currentExerciseIndex
                ? 'bg-primary/10 border border-primary/20'
                : index < currentExerciseIndex
                ? 'bg-muted/30 line-through'
                : 'bg-muted/30'
            }`}
          >
            <div className="flex items-center gap-2 mb-1">
              <div className={`w-2 h-2 rounded-full ${
                index === currentExerciseIndex
                  ? 'bg-primary animate-pulse'
                  : index < currentExerciseIndex
                  ? 'bg-success'
                  : 'bg-muted-foreground'
              }`} />
              <div className="flex-1">
                <div className="font-medium">{exercise.name}</div>
                <div className="text-sm text-muted-foreground">
                  {Math.floor(exercise.duration / 60)}:{(exercise.duration % 60).toString().padStart(2, '0')}
                </div>
              </div>
            </div>
            {exercise.description && (
              <div className="ml-4 text-sm text-muted-foreground">
                {exercise.description}
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}